/**
 * 索赔2.0-破损
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/23      1.0     First version
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React from "react";
import PropTypes from "prop-types";
import {Button, Spin, InputNumber, Alert, message} from "antd";
import FormFormat from '@/components/FormFormat/FormFormat';
import IntegerCtrlInput from "@components/Input/IntegerCtrlInput";// 数字组件
import {symbolMoneyUtil,toFixed2} from '@utils/utils';
import Lang from "@components/Lang/Lang";
import "./type.less"

export default class TypeBreakage extends React.Component{
    static propTypes = {
        sku:PropTypes.object,
        add:PropTypes.bool,
    }
    static defaultProps = {
        sku:{}, //sku 数据源
        add: true,
        fromInitialValues:{}, // 已保存过的数据 (add 为false)
    }
    constructor(props) {
        super(props);
        this.__getServerLanguage = __getServerLanguage;
        this.state = {
            loading:false,
            // 值
            fromInitialValues:{
                claimType:"10",
                ...props.fromInitialValues
            },
            values:{
                quantity: props.fromInitialValues.quantity ||1, // 退款产品数量
                normalQuantity:  props.fromInitialValues.normalQuantity || 0, // 正常产品数量
                wornQuantity: props.fromInitialValues.wornQuantity || 1, //破损产品数量
                refundAmountTotal: props.fromInitialValues.refundAmountTotal || (props.sku.pcsPrice? toFixed2(props.sku.pcsPrice*1):0),
            },

        }
    }
    // 更新 赔付数量
    updateNum(num,callback){
        const {sku} = this.props;
        let {values} = this.state;
        values["quantity"] = num;
        values["wornQuantity"] = num;
        values["normalQuantity"] = 0;
        values["refundAmountTotal"] = toFixed2(sku.pcsPrice * num);
        this.setState({
            values:values
        })
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 点击确认时 获取表单数据
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#6268
     ***/
    async handleOK(){
        const res = await this.onRefFormFormat.handleOK();
        const { values } = this.state;
        if(res&&res.success&&values.refundAmountTotal){
            // const sUrl = "/service/mg/sale/claimDemage/damaged-apply";
            const postData = {
                ...res.data,
                ...values,
            }
            if(this.props.saveData)this.props.saveData(postData)
        }else {
            message.error(Lang({id:"QingTianXieWanZhengDeBiTianXiang",default:"请填写完整的必填项"}));
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    // 赋值
    setValue(filed,value){
        let {values} = this.state;
        values[filed] = value;
        if(filed=="wornQuantity"){
            values["normalQuantity"] = values.quantity - value;
        }else if(filed=="normalQuantity"){
            values["wornQuantity"] = values.quantity - value;
        }
        this.setState({
            values:values
        })
    }
    // 修改索赔类型
    changeClaimType(claimType){
        let {fromInitialValues} =this.state;
        fromInitialValues["claimType"] = claimType;
        this.setState({
            fromInitialValues
        })
    }
    getOption(sku={},fromInitialValues={},quantity=1,sUnit,values={}){
        const {canApplyNum} = this.props;
        let list =  [
          {
              name:'damageCode',  // 售后原因
              title:<span className={"black89 fw_700 font_16"}>{this.__getServerLanguage('ShouHouYuanYin')}</span>,
              // cnTitleId:'ShouHouYuanYin',
              cnPlaceholderId:'QingXuanZeShouHouYuanYin',//请选择售后原因！
              required: true,
              type:"BtnSelect",
              list:__getDictList("claim_demage_order_damage_code")
          },
          {
              name:'quantity',  // 售后产品数量
              cnPlaceholderId:'TianXiePoSunChanPinShuLiangQingLiuYiDanWei',//填写破损产品数量，请留意单位
              // required: true,
              type:'OnlyRender',
              onlyRender:<div className={"font_14 mt_16"}>
                  <div className={"black89 fw_700 font_16"}>{Lang({id:'ShouHouTuiKuanChanPinShuLiang',default:"售后退款产品数量"})}
                  （{Lang({id:'KeHuGouMaiGongN',default:`客户购买共 ${sku.quantity+" "+sUnit}`,params:[sku.quantity+" "+sUnit]})}）
                  </div>
                  <div className={"color-err mt_4"}>{Lang({id:'GaiBuFenHuoWuKeHuBuYaoLeXuYaoTuiKuan',default:"该部分货物客户不要了，需要退款"})}</div>
                  <div className={" flex-item-ver-center mt_4"}>
                      <div className={"inputAdd"}>
                          <IntegerCtrlInput value={quantity}
                                            key={"integerCtrlInput_"+sku.id}
                                            quantity={1}
                                            minNumber={canApplyNum>0?1:0} //默认最少
                                            maxNumber={canApplyNum}
                                            callbackChange={false}
                                            onChange={(newValue,callback)=>this.updateNum(newValue,callback)} />
                      </div>
                      <div className={"ml_16 color-black"}>{sUnit} * {symbolMoneyUtil(sku.skuCount>1?(sku.pcsPrice||0):(sku.price||0), sku.currencySymbol)}，
                          {/*总计*/}
                          <span className={"ml_2 mr_2"}>{this.__getServerLanguage("ZongJi")}</span>
                          {symbolMoneyUtil(sku.pcsPrice*quantity, sku.currencySymbol)}
                      </div>
                  </div>
                  <div className={"black66 mt_4"}>
                      {sku.skuCount>1&&<span>{sku.skuCount} PCS/{__getServerDictItem("unit_type." + sku.skuUnit)} ，</span>}
                      {sku.skuCapacity}<span className={"ml_2"}>{__getServerDictItem("unit_type." + sku.skuUnit)}/{__getServerDictItem("prd_goods_out_box_unit." + sku.spuOutBoxUnit)||'-'}</span>，
                      {/*可索赔数量 {0}*/}
                      {Lang({id: "KeSuoPeiShuLiang",default: `可索赔数量 ${canApplyNum+" "+sUnit}`,params:[canApplyNum+" "+sUnit]})}
                      {/*历史已申请赔付了 {sku.claimQuantity} {sUnit}*/}
                      {sku.claimQuantity>0?<span className={"ml_2"}>
                          （{Lang({id: "LiShiYiShenQingPeiFuLe",default: `历史已申请赔付了 ${sku.claimQuantity+" "+sUnit}`,params:[sku.claimQuantity+" "+sUnit]})}）
                      </span>:null}
                  </div>
                  {/* 黄色数字输入区域 */}
                    <div className={"yellowNumberArea mt_16 mb_16 black89 autoRowNo"}>
                        <div className={"black100 fw_700"}>{Lang({id:'QueRenPoSunQingKuang',default:`确认破损情况（共 ${quantity+" "+sUnit}）`,params:[quantity+" "+sUnit]})}：</div>
                        <div className={"flex-item-ver-center mt_8"}>
                            <span className={"mr_8"}>{Lang({id:'ZhengChangChanPin',default:"正常产品"})}</span>
                            <InputNumber size={"large"}
                                         value={values.normalQuantity}
                                         width={220}
                                         min={0}
                                         max={quantity}
                                         onChange={(v)=>this.setValue("normalQuantity",v)}
                                         precision={0} />
                            <span className={"ml_8"}>{sUnit}</span>
                        </div>
                        <div className={"black66 mt_8"}>{Lang({id:'ZhengChangChanPinJiangZiDongZhuanKuCunShangPin',default:"正常产品将自动转库存商品，且会折算成整箱"})}</div>
                        <div className={"lineLigGrey mt_12"}></div>
                        <div className={"flex-item-ver-center mt_24"}>
                            <span className={"mr_8"}>{Lang({id:'PoSunChanPin',default:"破损产品"})}</span>
                            <InputNumber value={values.wornQuantity}
                                         size={"large"}
                                         width={220}
                                         min={0}
                                         max={quantity}
                                         onChange={(v)=>this.setValue("wornQuantity",v)}
                                         precision={0} />
                            <span className={"ml_8"}>{sUnit}</span>
                        </div>
                    </div>
              </div>,
          },
          {
              name:'consultFileList', // 上传凭证
              cnTitleId:'ShangChuanPingZheng',
              cnPlaceholderId:'QingShangChuanPingZheng',// 请上传凭证
              type:'UploadFileIcon',
              accept:'.mp4,.flv,.jpeg,.jpg,.png,.bmp,.doc,.docx,.xls, .xlsx, .pdf',
              topTips:<div className={"font_12 black45 m-under mb_4"}>{this.__getServerLanguage("ZhiChiTuPianShiPinWenDang")}</div>,
              required: this.props.add, // 发起时才是必填 | 调整编辑时可不填
              maxCount:5,
              fileSizeLimit: 20*1024*1024,
          },
            {
                name: 'refundAmountTotal',
                cnTitleId: 'ZongShouHouTuiKuan',// 售后方案 标题
                type: 'OnlyRender',
                onlyRender:(<div className={"font_14 planRow"}>
                    {/* 售后方案 */}
                    <div className={"lineLigGrey mb_16"} />
                    <div className={"fw_700 black89 font_16 mb_4"}>{Lang({id:"ShouHouFangAn",default:"售后方案"})}</div>
                    {/*总计*/}
                    <Alert message={<div className={"black89"}>
                        {Lang({id: "ShouHouTuiKuan",default: "售后退款"})}
                        <span className={"ml_4"}>{quantity} {sUnit} * {symbolMoneyUtil(sku.skuCount>1?(sku.pcsPrice||0):(sku.price||0), sku.currencySymbol)}，</span>
                        <span className={"ml_2 mr_2"}>{Lang({id: "ZongJi",default: "总计"})}</span>
                        {symbolMoneyUtil(sku.pcsPrice*quantity, sku.currencySymbol)}
                    </div>} type="warning" showIcon />
                </div>)
            },
          {
              name:'claimType',  // 	索赔方式 10:优惠券,20:现金
              cnPlaceholderId:'QingXuanZe',//请选择
              type:"BtnSelect",
              list:__getDictList("sale_po_claim_demage_order_claim_type"),
              callBack:(value)=>this.changeClaimType(value)
          },
            {
                name:'refundAmountTotal',
                cnTitleId:'ZongShouHouTuiKuan',// 总售后退款
                type:'OnlyRender',
                onlyRender:(<div className={"mb_16 bigSize"}>
                    <div className={"mb_4"}><span className={"color-red2"}>*</span>{Lang({id:"ZongShouHouTuiKuan",default:"总售后退款"})}</div>
                    <div className={"font_12 black45 mb_4"}>{fromInitialValues.claimType=="20"?Lang({id:"ShouHouTuiKuanYiXianJinFangShiTuiGeiKeHu",
                                default:"售后退款以现金方式退给客户，等客户上传申请表后汇款"}):Lang({id:"ShouHouTuiKuanYiYouHuiQuanFangShiTuiGeiKeHu",
                            default:`售后退款以优惠券方式发放给客户，满 ${values.refundAmountTotal?symbolMoneyUtil(toFixed2(values.refundAmountTotal* sku.priceMultiple),sku.currencySymbol):0} 减 ${values.refundAmountTotal?symbolMoneyUtil(values.refundAmountTotal,sku.currencySymbol):0}`,
                        params: values.refundAmountTotal?[symbolMoneyUtil(toFixed2(values.refundAmountTotal* sku.priceMultiple),sku.currencySymbol),
                            symbolMoneyUtil(values.refundAmountTotal, sku.currencySymbol)
                        ]:[0,0]})}</div>
                    <InputNumber value={values.refundAmountTotal}
                                 size={"large"}
                                 min={0.01}
                                 max={toFixed2(sku.pcsPrice * quantity)}
                                 addonAfter={<span className={"fw_700 font_16"}>{sku.currencySymbol}</span>}
                                 precision={2}
                                 onChange={(v)=>this.setValue("refundAmountTotal",v)} />
                </div>)
            },
          {
              name:'remark',// 说明
              cnTitleId:'ShuoMing',
              required: true,
              type:'TextArea',
              minRows: 5,
              maxLength: 512,
          },
      ]
     return list
    }
    componentWillMount() {

    }
    componentDidMount(){
    }

    render(){
        const {sku,add} = this.props;
        const { loading,fromInitialValues,values} = this.state;
        // 单位
        const sUnit = sku.skuCount>1?"PCS":__getServerDictItem("unit_type." + sku.skuUnit);
        return (<Spin spinning={loading}>
            <div className={"poSalesForm"}>
                {/*    表单 start */}
                {fromInitialValues&&<FormFormat onRef={this.onRefForm}
                            options={this.getOption(sku,fromInitialValues,values.quantity,sUnit,values)}
                            formItemLayout={null}
                            formLayout = "vertical"
                            initialValues={fromInitialValues} />}
                {/*    表单 end */}
                <div className={"btnWrap"}>
                    <Button type="primary" size={"large"} onClick={()=>this.handleOK()}>
                        {add?Lang({id:"FaQiShouHouTuiKuan",default:"发起售后退款"}):Lang({id:"TiaoZhengShouHouTuiKuan",default:"调整售后退款"})}
                    </Button>
                </div>
            </div>
        </Spin>)
    }
}
